import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

/** Avisos rápidos no rodapé (sucesso/erro). Use: const toast = useToast(); toast.ok('Salvo!'). */
type Tone = 'ok' | 'bad' | 'info';
interface ToastItem { id: number; tone: Tone; text: string }
interface ToastApi { ok: (t: string) => void; error: (t: string | unknown) => void; info: (t: string) => void }

const Ctx = createContext<ToastApi | null>(null);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<ToastItem[]>([]);
  const push = useCallback((tone: Tone, text: string) => {
    const id = Date.now() + Math.random();
    setItems((cur) => [...cur.slice(-2), { id, tone, text }]);
    setTimeout(() => setItems((cur) => cur.filter((i) => i.id !== id)), tone === 'bad' ? 6000 : 3500);
  }, []);
  const api: ToastApi = {
    ok: (t) => push('ok', t),
    info: (t) => push('info', t),
    error: (t) => push('bad', typeof t === 'string' ? t : (t as Error)?.message ?? 'Algo deu errado.'),
  };
  return (
    <Ctx.Provider value={api}>
      {children}
      <div className="toasts" aria-live="polite">
        {items.map((i) => <div key={i.id} className={`toast ${i.tone === 'info' ? '' : i.tone}`}>{i.tone === 'ok' ? '✓' : i.tone === 'bad' ? '⚠️' : 'ℹ️'} <span>{i.text}</span></div>)}
      </div>
    </Ctx.Provider>
  );
}

export function useToast() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useToast fora do ToastProvider');
  return ctx;
}
